import React from "react";
import {
  MenuContainer,
  SideBarButton,
  SideBarButtonActive,
  SideBarTitleButton,
  SideBarTitleButtonActive,
} from "./styles";
import { SubMenu } from "./SubMenu";
import { menuItems, MenuItem } from "./menuConfig";

interface MainMenuProps {
  isCollapsed: boolean;
  activeButton: string;
  subMenuStates: Record<string, boolean>;
  handleButtonClick: (buttonId: string) => void;
  toggleSubMenu: (menu: "flow" | "mypage") => void;
  expandSideBar: (menuId: "flow" | "mypage") => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({
  isCollapsed,
  activeButton,
  subMenuStates,
  handleButtonClick,
  toggleSubMenu,
  expandSideBar,
}) => {
  const renderMenuItem = (item: MenuItem) => {
    const isActive = item.id === activeButton;
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;
    const isSubMenuActive =
      hasSubMenu && item.subMenu?.some((sub) => sub.id === activeButton);
    const isTitleActive = isActive || isSubMenuActive;

    if (hasSubMenu && item.subMenu) {
      return (
        <React.Fragment key={item.id}>
          <SideBarTitleButton
            $isCollapsed={isCollapsed}
            $isTitle={true}
            onClick={() => {
              if (isCollapsed) {
                expandSideBar(item.id as "flow" | "mypage");
              } else {
                toggleSubMenu(item.id as "flow" | "mypage");
              }
            }}
            as={isTitleActive ? SideBarTitleButtonActive : undefined}
          >
            <item.Icon style={{ width: "24px", height: "24px" }} />
            <span>{item.label}</span>
          </SideBarTitleButton>
          <SubMenu
            isCollapsed={isCollapsed}
            isOpen={subMenuStates[item.id]}
            items={item.subMenu.map((subItem) => ({
              id: subItem.id,
              label: subItem.label,
              onClick: subItem.disabled
                ? () => {}
                : () => handleButtonClick(subItem.route || ""),
            }))}
            activeButton={activeButton}
          />
        </React.Fragment>
      );
    }

    return (
      <SideBarButton
        key={item.id}
        onClick={() => handleButtonClick(item.route || item.id)}
        $isCollapsed={isCollapsed}
        as={isActive ? SideBarButtonActive : SideBarButton}
      >
        <item.Icon style={{ width: "24px", height: "24px" }} />
        <span>{item.label}</span>
      </SideBarButton>
    );
  };

  return <MenuContainer>{menuItems.map(renderMenuItem)}</MenuContainer>;
};
